import React, {Component} from 'react';
import {List, ListItem} from 'framework7-react';
import SearchRow from './SearchRow'

/// Search results from the Buildings tab.
///
/// This component renders a SearchRow for each building that matches
/// the current search text.
export default class SearchResult extends Component {
    render() {
        const buildings = this.props.buildings;
        const search = new RegExp('.*' + this.props.searchTerm + '.*', 'im');
        const buildingItems = [];
        const matchBuildings = [];

        buildings.forEach(function(item) {
            if (item.name.match(search) || item.architect.match(search)) {
                matchBuildings.push(item);
            }
        });

        if (matchBuildings.length === 0) {
            buildings.forEach(function(item) {
                if (item.description.match(search)) {
                    matchBuildings.push(item);
                }
            });
        }

        matchBuildings.forEach(function(item) {
            buildingItems.push(
                <ListItem key={item.slug}>
                    <SearchRow building={item}/>
                </ListItem>
            );
        });

        return (
            <div>
                <List className="remove-top-margin" form>
                    {buildingItems}
                </List>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/SearchResult.jsx